import * as React from 'react'
import { CustomButton as Button } from './button';
import { Modal, ButtonGroup } from 'react-bootstrap';
//import { ButtonTypes, getButtonStyle } from 'style/buttonStyles'

export const AlertModal = ({ show, onHide, headerText, bodyText, confirmButtonAction, confirmButtonText, isHtml, showCancel, disableConfirm }: AlertModalProps): JSX.Element => {
    return (<Modal show={show} onHide={onHide}>
        <div>
            {headerText && (<Modal.Header>
                <Modal.Title>
                    {headerText}
                </Modal.Title>
            </Modal.Header>)}
            {isHtml ? (<div dangerouslySetInnerHTML={{ __html: bodyText }} />) : (<div className="row">
                <div className="col-md-10 col-md-offset-1 padding-vertical">
                    {bodyText}
                </div>
            </div>)}
        </div>
        <Modal.Footer style={{ display: !showCancel && !confirmButtonText ? 'none' : 'block' }}>
            <ButtonGroup>
                <Button onClick={confirmButtonAction} text={confirmButtonText} className="cyan-btn" show={confirmButtonText && confirmButtonText.length > 0} disabled={disableConfirm} />
                <Button onClick={onHide} text="Cancel" className="btn-danger" show={showCancel}></Button>    
            </ButtonGroup>
        </Modal.Footer>
    </Modal>);
}


interface AlertModalProps {
    show: boolean,
    onHide: any,
    headerText?: string,
    bodyText: any,
    confirmButtonAction?: any,
    confirmButtonText?: string,
    isHtml?: boolean,
    showCancel?: boolean,
    disableConfirm?: boolean
}
